import type { ReactNode } from 'react';

export default function SVGGradientFiller({
  stop,
  id,
}: {
  stop: { from: string; via?: string; to: string };
  id: string; // Reference this ID to SVG
}): ReactNode {
  return (
    <svg height="0" width="0">
      <linearGradient id={id} x1="100%" x2="0%" y1="100%" y2="0%">
        <stop offset="0%" stopColor={stop.from} />
        {stop.via ? <stop offset="50%" stopColor={stop.via} /> : null}
        <stop offset="100%" stopColor={stop.to} />
      </linearGradient>
    </svg>
  );
}
